import leadingZeroes from 'leading-zeroes';
import { appConstant } from 'Util/constants';
import _ from 'lodash'
import moment from 'moment'
import { cleanTitle, getDate, getTimeFromDate } from 'Util/common';

export const statusQuery = (statusArr) => ({
    variables: {
        where: {
            "active": { "_eq": true },
            "_or": statusArr.map(s => ({ "status": { "_eq": s } }))
        }
    }
})

export const dataSource = (key = 'open', data) => {

    if (_.isUndefined(data)) {
        return []
    }

    return data.direct_offers.map((v, i) => (
        {
            ...v,
            key: `key-${i}-direct-offers-${key}-list`,
            location: v.user_info.user_location.label || "",
            vendor: leadingZeroes(v.user_id, appConstant.leadingZero),
            time: getTimeFromDate(v.created_at, true),
            date: getDate(v.created_at),
            po: !_.isNull(v.purchase_order) ? leadingZeroes(v.purchase_order.id, appConstant.leadingZero) : v.purchase_order
        }
    ))
}

export const commonColumns = [
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'do-date',
        sorter: (a, b) => (moment(a.created_at).unix() - moment(b.created_at).unix()),
        sortDirections: ['descend', 'ascend'],
        defaultSortOrder: 'descend',
    },
    {
        title: 'Time',
        dataIndex: 'time',
        editable: true,
    },
    {
        title: 'DO#',
        dataIndex: 'id',
        sorter: { compare: (a, b) => a.id - b.id },
        render: (_, rec) => (<span>{leadingZeroes(rec.id, appConstant.leadingZero)}</span>)
    },
    {
        title: 'Vendor ID',
        dataIndex: 'vendor',
        sorter: { compare: (a, b) => a.vendor - b.vendor },
        editable: true,
    },
    {
        title: 'Location',
        dataIndex: 'location',
        editable: true,
    },
    {
        title: 'Species',
        dataIndex: 'species_name',
        editable: true,
    },
    {
        title: 'Category',
        dataIndex: 'category',
        editable: true,
    },
    {
        title: 'Preservation',
        dataIndex: 'preservation_method',
        editable: true,
    },
    {
        title: 'Origin',
        dataIndex: 'country_origin',
        editable: true,
    },
    {
        title: 'Harvest',
        dataIndex: 'harvest_method',
        editable: true,
    },
    {
        title: 'Available(KG)',
        dataIndex: 'avail_quantity',
        render: (_, rec) => (<span>{rec.avail_quantity} / {rec.quantity}</span>),
        editable: true,
    },
    {
        title: 'MOQ(KG)',
        dataIndex: 'min_quantity',
        editable: true,
    },
    {
        title: 'Offer Price',
        dataIndex: 'price',
        editable: true,
    },
    {
        title: 'Offer Type',
        dataIndex: 'offer_type',
        editable: true,
    }
]


export const acceptedColumns = [

    {
        title: 'Date',
        dataIndex: 'date',
        key: 'do-date',
        sorter: (a, b) => (moment(a.created_at).unix() - moment(b.created_at).unix()),
        sortDirections: ['descend', 'ascend'],
        defaultSortOrder: 'descend',
    },
    {
        title: 'Time',
        dataIndex: 'time',
        editable: true,
    },
    {
        title: 'DO#',
        dataIndex: 'id',
        sorter: { compare: (a, b) => a.id - b.id },
        render: (_, rec) => (<span>{leadingZeroes(rec.id, appConstant.leadingZero)}</span>)
    },
    {
        title: 'Vendor ID',
        dataIndex: 'vendor',
        sorter: { compare: (a, b) => a.vendor - b.vendor },
        editable: true,
    },
    {
        title: 'Location',
        dataIndex: 'location',
        editable: true,
    },
    {
        title: 'Species',
        dataIndex: 'species_name',
        editable: true,
    },
    {
        title: 'Category',
        dataIndex: 'category',
        editable: true,
    },
    {
        title: 'Preservation',
        dataIndex: 'preservation_method',
        editable: true,
    },
    {
        title: 'Origin',
        dataIndex: 'country_origin',
        editable: true,
    },
    {
        title: 'Harvest',
        dataIndex: 'harvest_method',
        editable: true,
    },
    {
        title: 'Price',
        dataIndex: 'price',
        editable: true,
    },
    {
        title: 'Offer Type',
        dataIndex: 'offer_type',
        editable: true,
    },
    {
        title: 'Order',
        dataIndex: 'order_quantity',
    },
    {
        title: 'PO#',
        dataIndex: 'po',
        editable: true,
    },

]